var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0458984 1.32089C0.0458984 0.751498 0.507481 0.289917 1.07687 0.289917L22.2932 0.289917L38.9787 16.9754V43.7536C38.9787 44.3229 38.5171 44.7845 37.9477 44.7845H1.07687C0.507481 44.7845 0.0458984 44.3229 0.0458984 43.7536V1.32089Z",
    fill: "#F85640"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2395 31.7448C13.2395 32.1499 13.1418 32.5297 12.9464 32.8843C12.7583 33.2388 12.4581 33.5245 12.0457 33.7416C11.6405 33.9586 11.1269 34.0672 10.5047 34.0672H9.23494V36.9756H7.71561V29.4006H10.5047C11.0907 29.4006 11.5899 29.5019 12.0023 29.7045C12.4147 29.9071 12.7222 30.1856 12.9247 30.5401C13.1345 30.8947 13.2395 31.2962 13.2395 31.7448ZM10.4395 32.8408C10.8592 32.8408 11.1703 32.7468 11.3728 32.5587C11.5754 32.3633 11.6767 32.092 11.6767 31.7448C11.6767 31.0068 11.2643 30.6378 10.4395 30.6378H9.23494V32.8408H10.4395ZM17.5087 29.4006C18.3046 29.4006 19.0028 29.5562 19.6033 29.8673C20.211 30.1784 20.6776 30.6233 21.0032 31.2021C21.336 31.7737 21.5024 32.4393 21.5024 33.199C21.5024 33.9586 21.336 34.6242 21.0032 35.1958C20.6776 35.7601 20.211 36.1978 19.6033 36.5089C19.0028 36.82 18.3046 36.9756 17.5087 36.9756H14.8608V29.4006H17.5087ZM17.4545 35.6842C18.2503 35.6842 18.8653 35.4671 19.2994 35.033C19.7335 34.5989 19.9505 33.9876 19.9505 33.199C19.9505 32.4104 19.7335 31.7954 19.2994 31.3541C18.8653 30.9055 18.2503 30.6812 17.4545 30.6812H16.3801V35.6842H17.4545ZM27.8597 29.4006V30.627H24.7016V32.5695H27.1217V33.7741H24.7016V36.9756H23.1823V29.4006H27.8597Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.293 0.289917L38.9784 16.9754H23.3239C22.7545 16.9754 22.293 16.5138 22.293 15.9444V0.289917Z",
    fill: "#D13F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7e05bc962cc6e11a4da1bb021fbcc447.svg";
export { ForwardRef as ReactComponent };